import { OdataManager } from '@/api/odata/odata-manager';
import { Line } from '@/api/model/interfaces';

export default class LineOdata extends OdataManager<Line> {}
